'use client'

import { CopyIcon } from '@phosphor-icons/react'
import { Button } from '@skop-app/lib-front'

interface CopyableTextProps {
  text: string
  displayText?: string
  className?: string
  onCopy?: () => void
}

export function CopyableText({
  text,
  displayText,
  className = '',
  onCopy = () => {},
}: CopyableTextProps) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      onCopy()
    } catch (err) {
      console.error('Failed to copy text:', err)
    }
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span className="text-sm text-gray-700">{displayText || text}</span>
      <Button
        variant="ghost"
        size="sm"
        className="h-auto p-1 hover:bg-gray-200"
        onClick={handleCopy}
        title="Copier"
      >
        <CopyIcon className="size-4" />
      </Button>
    </div>
  )
}
